import { default as domainSmartshare }                  from './smartshare/services'
import { default as domainIntegration }                  from './integration/services'
import { default as domainIntegrationAzureAd }           from './azure-ad/services'
import { default as domainIntegrationDatabricksImport }  from './databricks-import/services'

export default {
	domainSmartshare,
	domainIntegration,
	domainIntegrationAzureAd,
	domainIntegrationDatabricksImport,
}
